import { CurrentUser } from "Roblox";
import angular from "angular";
import chatModule from '../chatModule';

function playTogetherService($log) {
    "ngInject";

    return {
        isPlacePlayersOnlyMe: function (conversation, rootPlaceId) {
            if (conversation.playTogetherDict && conversation.playTogetherDict[rootPlaceId]) {
                var playerIds = conversation.playTogetherDict[rootPlaceId].playerIds;
                if (playerIds && playerIds.length === 1 && playerIds[0] === parseInt(CurrentUser.userId)) { // user will not see the self-play game
                    return true;
                }
            }
            return false;
        },

        setPlaceForShown: function (conversation) {
            // set active game for shown first
            if (conversation.playTogetherIds && conversation.playTogetherIds.length > 0) {
                var latestSeenRootPlaceId = conversation.playTogetherIds[0];
                if (!this.isPlacePlayersOnlyMe(conversation, latestSeenRootPlaceId)) {
                    conversation.placeForShown = {
                        rootPlaceId: latestSeenRootPlaceId
                    }
                }
            } else if (conversation.pinGame) { // then pinned game
                var rootPlaceId = conversation.pinGame.rootPlaceId;
                conversation.placeForShown = {
                    rootPlaceId: rootPlaceId
                }
            } else {
                conversation.placeForShown = null;
            }
        },

        sortPlayTogetherIds: function (conversation, presenceData) {
            if (!conversation || !presenceData || !presenceData.rootPlaceId) {
                return false;
            }
            var rootPlaceId = parseInt(presenceData.rootPlaceId);
            var placeId = parseInt(presenceData.placeId);
            var gameInstanceId = presenceData.gameId;
            var playerId = parseInt(presenceData.userId);
            var lastSeen = presenceData.lastOnline;
            if (lastSeen) {
                lastSeen = new Date(lastSeen).getTime();
            }
            if (!conversation.playTogetherIds) {
                conversation.playTogetherIds = [rootPlaceId];
                conversation.playTogetherDict = {};
                var gameInstancesDict = {};
                gameInstancesDict[gameInstanceId] = {
                    lastSeen: lastSeen
                }
                conversation.playTogetherDict[rootPlaceId] = {
                    playerIds: [playerId],
                    gameInstanceId: gameInstanceId,
                    lastSeen: lastSeen,
                    placeId: placeId
                }
                return false;
            }

            if (!conversation.playTogetherDict[rootPlaceId]) {
                conversation.playTogetherDict[rootPlaceId] = {
                    playerIds: [playerId],
                    gameInstanceId: gameInstanceId,
                    lastSeen: lastSeen,
                    placeId: placeId
                }
            } else if (conversation.playTogetherDict[rootPlaceId].placeId !== placeId) {
                conversation.playTogetherDict[rootPlaceId].placeId = placeId;
            }

            // active game id by number of players
            if (conversation.playTogetherDict[rootPlaceId].playerIds.indexOf(playerId) < 0) {
                conversation.playTogetherDict[rootPlaceId].playerIds.push(playerId);
            }

            if (conversation.playTogetherDict[rootPlaceId]) {
                var numberOfPlayers = conversation.playTogetherDict[rootPlaceId].playerIds.length;
                angular.forEach(conversation.playTogetherIds, function (placeId, idx) {
                    var existingPlayerIds = conversation.playTogetherDict[placeId].playerIds;
                    if (existingPlayerIds.indexOf(playerId) > -1 && rootPlaceId !== placeId) { // means player also existed in other place, should remove
                        var position = existingPlayerIds.indexOf(playerId);
                        conversation.playTogetherDict[placeId].playerIds.splice(position, 1);
                    }

                    var count = conversation.playTogetherDict[placeId].playerIds.length;
                    if (count < numberOfPlayers) {
                        conversation.playTogetherIds.splice(idx, 0, rootPlaceId);
                        return false;
                    }
                });

                if (conversation.playTogetherIds.indexOf(rootPlaceId) < 0) {
                    conversation.playTogetherIds.push(rootPlaceId);
                }
            }

            // if there is multiple game instances happening, sort by last seen
            var existingLastSeen = conversation.playTogetherDict[rootPlaceId].lastSeen;
            if (existingLastSeen < lastSeen) { // same game instance there, update last seen and compare other game instance last seen
                conversation.playTogetherDict[rootPlaceId].gameInstanceId = gameInstanceId;
                conversation.playTogetherDict[rootPlaceId].lastSeen = lastSeen;
            }
            conversation.recentPlaceIdFromPresence = presenceData.rootPlaceId;
            conversation.recentUserIdFromPresence = presenceData.userId;
        }
    }
};

chatModule.factory("playTogetherService", playTogetherService);

export default playTogetherService;